module.exports = __webpack_public_path__ + "img/status-2@3x.83eb82f1.png";